<template>
  <div class="row card-body">
    <div class="col-md-4">
      <div class="card card-primary">
        <div class="card-body">
          <h3 class="text-center">Sign-Up Now!</h3>
          <hr />

          <p>
            <strong v-html="webinar.subject"></strong>
          </p>

          <p>
            <span class="glyphicon glyphicon-calendar"></span>
            <strong>Date:</strong>
            {{ webinar.start | formatDateNoSeconds }} CST
          </p>
          <p class="voffset30 text-center">
            <a
              class="btn btn-xlg btn-warning"
              :href="'/webinars/unregister/' + webinar.id"
              v-if="webinar.registered"
            >
              <span>Unregister</span>
            </a>
            <a
              class="btn btn-xlg btn-warning"
              :href="'/webinars/register/' + webinar.id"
              v-else
            >
              <span>Register Now</span>
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-8" style="text-align: justify">
      <h4 v-html="webinar.subject"></h4>
      <p v-html="webinar.description"></p>
      <p>{{ webinar.presenterDisplayName }}</p>
      <p>{{ webinar.presenterBio }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpcomingWebinar",
  props: {
    webinar: Object,
  },
};
</script>

<style lang="postcss">
.card-primary {
  background: none repeat scroll 0 0 #035995;
  border-color: #035995;
  color: #fff;
}

.card-primary .card-body {
  background: none repeat scroll 0 0 #035995;
}
</style>